// src/utils/globalSessionGuard.js
let lastCheck = 0;
let installed = false;

export function installGlobalSessionGuard({
  verifyUrl,
  redirectPath = "/sign-in",
  minIntervalMs = 8000,
  enableServerVerify = true,
} = {}) {
  if (installed) return;
  installed = true;

  const hardRedirect = () => {
    try {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
    } catch {}
    window.location.assign(redirectPath);
  };

  const verifyToken = async () => {
    const now = Date.now();
    if (now - lastCheck < minIntervalMs) return;
    lastCheck = now;

    const token = localStorage.getItem("access_token");
    if (!token) {
      hardRedirect();
      return;
    }
    if (!enableServerVerify || !verifyUrl) return;

    try {
      const res = await fetch(verifyUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token }),
      });
      if (!res.ok) hardRedirect();
    } catch {}
  };

  const onUserActivity = () => {
    // ✅ 현재 경로 확인 (로그인 관련 페이지에서는 무시)
    const path = window.location.pathname;
    const isAuthPage =
      path.startsWith("/sign") ||
      path.startsWith("/auth") ||
      path.startsWith("/landing");

    if (isAuthPage) return; // 로그인 화면에서는 감시 중단

    const token = localStorage.getItem("access_token");
    if (!token) {
      hardRedirect();
      return;
    }

    verifyToken();
  };

  window.addEventListener("click", onUserActivity, true);
  window.addEventListener("keydown", onUserActivity, true);
  window.addEventListener("forceSignOut", hardRedirect);
}